import { Org } from "src/hooks/useOrg";
import type { Notification } from "pages/api/[orgId]/notifications/types";
import {
  SourceType,
  Source,
} from "pages/api/[orgId]/integrations-client/definitions";
import createSecretRoute from "pages/api/[orgId]/sources/create-secret.route";
import updateSecretRoute from "pages/api/[orgId]/sources/update-secret.route";
import getSourceRoute from "pages/api/[orgId]/sources/get-source.route";
import getAppInstallRoute from "pages/api/[orgId]/sources/get-install-url.route";
import createSourceRoute from "pages/api/[orgId]/sources/create-source.route";
import updateSourceRoute from "pages/api/[orgId]/sources/update-source.route";
import listSourcesRoute from "pages/api/[orgId]/sources/list-sources.route";
import dismissNotificationRoute from "pages/api/[orgId]/notifications/dismiss.route";
import getNotificationsRoute from "pages/api/[orgId]/notifications/get-notifications.route";
import { post } from "./lib";

export const listSources = async (orgId: Org["id"]) =>
  post<typeof listSourcesRoute>(`/api/${orgId}/sources/list-sources`);

export const getSource = async (orgId: Org["id"], type: SourceType) =>
  post<typeof getSourceRoute>(`/api/${orgId}/sources/get-source`, { type });

export const createSource = async (orgId: Org["id"], type: SourceType) =>
  post<typeof createSourceRoute>(`/api/${orgId}/sources/create-source`, {
    type,
  });

export const updateSource = async (
  orgId: Org["id"],
  type: SourceType,
  source: Pick<Source, "id"> &
    Partial<
      Pick<Source, "authToken" | "username" | "host" | "scope" | "secret">
    >
) =>
  post<typeof updateSourceRoute>(`/api/${orgId}/sources/update-source`, {
    type: type,
    ...source,
  });

export const createSecret = async (
  orgId: Org["id"],
  type: SourceType,
  sourceId: string,
  secret: string
) =>
  post<typeof createSecretRoute>(`/api/${orgId}/sources/create-secret`, {
    type,
    sourceId,
    secret,
  });

export const updateSecret = async (
  orgId: Org["id"],
  type: SourceType,
  sourceId: string,
  id: string,
  secret: string
) =>
  post<typeof updateSecretRoute>(`/api/${orgId}/sources/update-secret`, {
    type,
    sourceId,
    id,
    secret,
  }).then((payload) => Boolean(payload.data?.secret));

export const dismissNotification = async (
  orgId: Org["id"],
  id: Notification["id"]
) =>
  post<typeof dismissNotificationRoute>(`/api/${orgId}/notifications/dismiss`, {
    id,
  });

export const getNotifications = async (orgId: Org["id"]) =>
  post<typeof getNotificationsRoute>(
    `/api/${orgId}/notifications/get-notifications`
  );

export const getGithubAppInstallUrl = (orgId: Org["id"]) =>
  post<typeof getAppInstallRoute>(`/api/${orgId}/sources/get-install-url`);
